import type { ReactNode } from 'react';

export const symbol_bookmark_check: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m438-509-36-36q-9-9-21-8.5t-21 9.5q-9 9-9 21t9 21l56 57q9.07 9 21.53 9 12.47 0 21.47-9l141-142q9-9 9-21t-9-21q-9-9-21-9t-21 9L438-509Zm42 269-196 84q-30 13-57-4.76-27-17.75-27-50.24v-574q0-24 18-42t42-18h440q24 0 42 18t18 42v574q0 32.49-27 50.24Q706-143 676-156l-196-84Zm0-64 220 93v-574H260v574l220-93Zm0-481H260h440-220Z"
		/>
	</svg>
);
